module.exports = __webpack_public_path__ + "static/media/homer-static.12742f09.png";